//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { createFieldConfig, Store } from '../../../../components/QSelectUtils.js'
import ItemsSearchField from '../../../../components/Field/ItemsSearchField.vue'

export default {
  components: {
    ItemsSearchField
  },
  props: {
    resultName: {
      type: String,
      default: ''
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      searchConfig: createFieldConfig(new Store({
        fullReadable: false,
        cached: true,
        proxy: {
          urlBase: '/service/obj/search?subtypes=true&type=' + (this.resultValue.objectChooseTypes && this.resultValue.objectChooseTypes.toString())
        }
      })),
      selectionDialogColumns: [
        {
          name: 'name',
          label: 'Название',
          align: 'left',
          defaultWidth: 130,
          field: 'name',
          sortable: true
        }
      ]
    }
  },
  computed: {
    value: {
      set: function (val) {
        this.resultValue.value = val ? { id: val.id, name: val.name, type: val.type } : null
      },
      get: function () {
        return this.resultValue.value
      }
    }
  }
}

